InspecFinDialogCtrl.$inject = ['$log', '$scope', 'Entidad'];
export default function InspecFinDialogCtrl($log, $scope, Entidad) {

    var entidadesReparadoras = [];

    $scope.onCambiaTipo = onCambiaTipo;

    $scope.resultados = $scope.model.datos.resultados;
    // .filter(function (element) {
    //         return element.incidencia_pendiente == $scope.model.incidenciaEstaPendiente;
    //     });

    if ($scope.model.incidenciaEstaPendiente) {
        var resultadosConTipoYReparador = $scope.resultados.filter(function (res) {
            return res.seleccionar_tipo_y_reparador;
        });
        // Por defecto el primero que tenga seleccionar tipo y reparador
        $scope.resultado = resultadosConTipoYReparador[0];
    } else {
        $scope.resultado = $scope.resultados[0];
    }

    $scope.model.datos.resultados.some(function (element) {
        if (element.seleccionar_tipo_y_reparador) {
            $scope.resultadoConTipo = element;
            $scope.model.resultado_id = element.id;
            return true;
        }
    });

    $scope.onCambiaResultado = function (res) {
        $scope.model.resultado_id = res.id;
    };

    cargarEntidadesRepradoras();

    function onCambiaTipo(tipoId) {
        obtenerTipo(tipoId);
        if (tipoId == Sigo.config.tipo.varios) {
            $scope.entidades = entidadesReparadoras;
            $scope.model.entidad_id = entidadesReparadoras.length > 0 ? entidadesReparadoras[0].id : null;
        } else {
            var tipo = obtenerTipo(tipoId);
            $scope.entidades = tipo.entidades_reparadoras;
            if (issetAndNotEmpty(tipo.entidad_reparadora_id))
                $scope.model.entidad_id = tipo.entidad_reparadora_id;
            else if (tipo.entidades_reparadoras.length > 0)
                $scope.model.entidad_id = tipo.entidades_reparadoras[0].id;
            else
                $scope.model.entidad_id = null;
        }
    }

    function obtenerTipo(tipoId) {
        var tipo = null;
        $scope.model.datos.tipos.some(function (element) {
            if (element.id == tipoId) {
                tipo = element;
                return true;
            }
        });
        return tipo;
    }

    function cargarEntidadesRepradoras() {
        return Entidad.get({rol: 'REPARADOR'}, function (data) {
            entidadesReparadoras = data.data;
            onCambiaTipo($scope.model.tipo_id);
        });
    }

    $scope.anyadirImagenes = function () {
        Adjuntos.openDialogAddFiles($scope.model.incidencia_id, 'incidencias');
    };

}